'use client';
import React, { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import PropTypes from 'prop-types';
import { HeaderButton } from '../Header/HeaderButton';
import { SlideDownMenuSlider } from './SlideDownMenuSlider';

export const SlideDownMenuLink = ({
  header,
  headerBackgroundColor = 'background.dark',
  headerFontColor = 'text.lightest',
  menuBgColor,
  categories,
  onCloseMenu,
}) => {
  const [active, setActive] = useState(false);
  const pathname = usePathname();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname;
      setActive(false);
      onCloseMenu?.();
    }
  }, [pathname, onCloseMenu]);

  const handleCloseMenu = () => {
    onCloseMenu?.();
    setActive(false);
  };
  const handleGoBack = () => setActive(false);

  const handleOpenAndClose = () => {
    if (active === false) {
      setActive(true);
    } else {
      setActive(false);
    }
  };
  return (
    <>
      <HeaderButton
        text={header}
        onClick={() => {
          handleOpenAndClose();
        }}
      />
      <SlideDownMenuSlider
        header={header}
        categories={categories}
        onCloseMenu={handleCloseMenu}
        active={active}
        onGoBack={handleGoBack}
        headerBackgroundColor={headerBackgroundColor}
        headerFontColor={headerFontColor}
        menuBgColor={menuBgColor}
      />
    </>
  );
};

SlideDownMenuLink.propTypes = {
  categories: PropTypes.array.isRequired,
  header: PropTypes.string.isRequired,
  headerBackgroundColor: PropTypes.string,
  headerFontColor: PropTypes.string,
  onCloseMenu: PropTypes.func,
  menuBgColor: PropTypes.string,
};
